var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imgList!=null)?_c('span',[_c('viewer',{attrs:{"images":_vm.listJsonToList(_vm.imgList,'url')}},_vm._l((_vm.imgList),function(o){return _c('img',{attrs:{"src":o.url,"width":_vm.width,"height":_vm.height}})}),0)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0049a3d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/kc/keTemp/imgView.vue
// module id = null
// module chunks = 